import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import { FieldRenderProps } from 'react-final-form'
import Icon from '../../Icon'
import { FieldIcon, Input as StyledInput } from './styles'
import { AutocompleteData, Html } from './type'

interface Props extends FieldRenderProps<string, HTMLInputElement> {
  id: string
  data: AutocompleteData
  html: Html
}

const Autocomplete: React.FC<Props> = ({ id, input, html, data }) => {
  const hashDatalistId = Math.random().toString(36).substr(2, 5)
  const [autocompleteData, setAutocompleteData] = useState<any[]>(data.options)
  const [cities, setCities] = useState<any[]>([])
  const ref = React.createRef<HTMLInputElement>()

  useEffect(() => {
    let mounted = true
    const timer = setTimeout(() => {
      let value = input.value
      if (value && value.length >= 3) {
        Axios({
          method: 'GET',
          url: `${process.env.REACT_APP_API_URL}/cities/${value}/search`,
        }).then(({ data }) => {
          if (mounted) {
            let newCityOptions: any[] = []
            data.data.forEach((element: any) => {
              newCityOptions.push({ value: element.city })
            })
            setTimeout(() => {
              setAutocompleteData(newCityOptions)
              if (ref.current) {
                ref.current.click()
                ref.current.click()
              }
              setCities(data.data)
            }, 1)
          }
        })
      }
      if (!value) {
        setAutocompleteData([])
      }
    }, 600);
    return () => {
      mounted = false
      clearTimeout(timer)
    }
  }, [input.value])

  return (<>
    {data.icon && (
      <FieldIcon>
        <Icon
          name={data.icon}
        />
      </FieldIcon>
    )}

    <StyledInput
      autoComplete="on"
      ref={ref}
      list={hashDatalistId}
      id={id}
      {...input}
      {...html}
    />
    <datalist id={hashDatalistId}>
      {autocompleteData.map((option, index) => (
        <option
          key={`${hashDatalistId}_${index}`}
          value={option.value}
        />
      ))}
    </datalist>

    <span></span>
  </>
  )
}

export default Autocomplete
